/* eslint-disable @typescript-eslint/naming-convention */
import { ParameterInfos } from 'ut-business/parameter';

const ASCAN_RANGE_PARAMETER_INFOS: ParameterInfos = {
  metric: {
    unit: 'mm',
    decimals: 2,
    defaultStep: 1,
    steps: [
      0.01,
      0.1,
      1,
      10,
    ],
  },
  imperial: {
    unit: 'in',
    decimals: 3,
    defaultStep: 0.05,
    steps: [
      0.005,
      0.05,
      0.5,
      5,
    ],
  },
  timeOfFlight: {
    unit: 'µs',
    decimals: 3,
    defaultStep: 1,
    steps: [
      0.01,
      0.1,
      1,
      10,
    ],
  },
  sourceUnit: 'm',
  inspectionMode: {
    setup: {
      isReadOnly: false,
    },
    inspection: {
      isReadOnly: true,
    },
    pause: {
      isReadOnly: true,
    },
    analysis: {
      isReadOnly: true,
    },
  },
};

export const utSettingsParameters: Record<string, ParameterInfos> = {
  UtSettings_AscanResolution: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 3,
    },
    imperial: {
      unit: 'in',
      decimals: 5,
    },
    timeOfFlight: {
      unit: 'µs',
      decimals: 3,
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_GeneralGain: {
    metric: {
      unit: 'dB',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'dB',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_SoftGain: {
    metric: {
      unit: 'dB',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'dB',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  UtSettings_ReferenceGain: {
    metric: {
      unit: 'dB',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'dB',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_Skew: {
    metric: {
      unit: '°',
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_WedgeDelay: {
    metric: {
      unit: 'µs',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'µs',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    sourceUnit: 's',
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_Velocity: {
    sourceUnit: 'm/s',
    metric: {
      unit: 'm/s',
      decimals: 1,
    },
    imperial: {
      unit: 'in/µs',
      decimals: 4,
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_AscanSynchroMode: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_SoftAscanSynchroMode: {
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  UtSettings_UltrasoundMode: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  UtSettings_HighAmplitude: {
    metric: {
      unit: '%',
    },
    imperial: {
      unit: '%',
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_Voltage: {
    metric: {
      unit: 'V',
    },
    imperial: {
      unit: 'V',
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
    sourceUnit: 'V',
  },
  UtSettings_Damping: {
    metric: {
      unit: 'Ω',
    },
    imperial: {
      unit: 'Ω',
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
    sourceUnit: 'Ω',
  },
  UtSettings_DigitizingFrequency: {
    metric: {
      unit: 'MHz',
    },
    imperial: {
      unit: 'MHz',
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
    sourceUnit: 'Hz',
  },
  UtSettings_PulseWidth: {
    metric: {
      unit: 'ns',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'ns',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    sourceUnit: 's',
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_PulserMode: {
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_Rectification: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_Averaging: {
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_SmoothingFilter: {
    metric: {
      unit: 'MHz',
    },
    imperial: {
      unit: 'MHz',
    },
    sourceUnit: 'Hz',
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_DigitalBandPassFilter: {
    metric: {
      unit: 'MHz',
    },
    imperial: {
      unit: 'MHz',
    },
    sourceUnit: 'Hz',
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_AscanCompressionFactor: {
    metric: {
      limit: {
        min: 1,
      },
      unit: '',
      decimals: 0,
      defaultStep: 1,
      steps: [
        1,
        10,
      ],
    },
    imperial: {
      limit: {
        min: 1,
      },
      unit: '',
      decimals: 0,
      defaultStep: 1,
      steps: [
        1,
        10,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_Beam_GainOffset: {
    metric: {
      unit: 'dB',
      decimals: 1,
    },
    imperial: {
      unit: 'dB',
      decimals: 1,
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_Beam_BeamDelay: {
    metric: {
      unit: 'µs',
      decimals: 3,
    },
    imperial: {
      unit: 'µs',
      decimals: 3,
    },
    sourceUnit: 's',
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_Beam_RefractedAngle: {
    metric: {
      unit: '°',
      decimals: 0,
    },
    imperial: {
      unit: '°',
      decimals: 0,
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_Beam_SumGain: {
    metric: {
      unit: 'dB',
      decimals: 1,
    },
    imperial: {
      unit: 'dB',
      decimals: 1,
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_BeamGainTotal: {
    metric: {
      unit: 'dB',
      decimals: 2,
    },
    imperial: {
      unit: 'dB',
      decimals: 2,
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_BeamGainOffset: {
    metric: {
      unit: 'dB',
      decimals: 2,
    },
    imperial: {
      unit: 'dB',
      decimals: 2,
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_Beam_AscanStart: ASCAN_RANGE_PARAMETER_INFOS,
  UtSettings_Beam_AscanLength: ASCAN_RANGE_PARAMETER_INFOS,
  UtSettings_Polarity: {
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_NetDigitizingFrequency: {
    metric: {
      unit: 'MHz',
    },
    imperial: {
      unit: 'MHz',
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
    sourceUnit: 'Hz',
  },

  UtSettings_PointQuantity: {
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_Beam_xValue: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 1,
    },
    imperial: {
      unit: 'in',
      decimals: 3,
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_BitDepth: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_ReferenceGainEnabled: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_Reject: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
};
